<script>
  import { formatPrice } from '../services/utilities.js';
  export let rates = [];
  export let selectedRate;

</script>

{#if rates}
  <section class="shipping-rates">
    {#each rates as rate, i}
    <div>
      <input
        class="form-input form-radio"
        type="radio"
        value={rate.courier_id}
        name="courier"
        checked={i === 0}
        on:click={() => {selectedRate = rate}}
      />
      {rate.courier_name}
      <!-- - {rate.max_delivery_time} Business Days -->
      - {formatPrice(rate.shipment_charge_total_int)}
    </div>
    {/each}
  </section>
{/if}

<style>
  .shipping-rates {
    display: flex;
    flex-direction: column;
  }
</style>